import GlobalVariables, { GLOBAL_VARIABLES } from "./global.ts";

class LogUtils {
    private static instance: LogUtils;
    private TAG: string = '[si-anti-spider-pay]';
    private constructor() {
        // Private constructor to prevent instantiation
    }

    private isPro() {
        const env = GlobalVariables?.get(GLOBAL_VARIABLES.ENV);
        return env === 'production';
    }

    public static getInstance(): LogUtils {
        if (!LogUtils.instance) {
            LogUtils.instance = new LogUtils();
        }
        return LogUtils.instance;
    }

    public info(title: string, message: string): void {
        if (this.isPro()) return;
        console.log(
            `%c${this.TAG}%c ${title}: %c${message}`,
            'background:#222;color:#fff;border-radius:3px 0 0 3px;padding:2px 6px;font-weight:bold;',
            'background:#ff4d4f;color:#fff;border-radius:0;padding:2px 6px;',
            'background:#fff3cd;color:#856404;border-radius:0 3px 3px 0;padding:2px 6px;'
        );
    }

    public warn(title: string, message: string): void {
        if (this.isPro()) return;
        console.warn(
            `%c${this.TAG}%c ${title}: %c${message}`,
            'background:#222;color:#fff;border-radius:3px 0 0 3px;padding:2px 6px;font-weight:bold;',
            'background:#ff4d4f;color:#fff;border-radius:0;padding:2px 6px;',
            'background:#fff3cd;color:#856404;border-radius:0 3px 3px 0;padding:2px 6px;'
        );
    }

    public error(title: string, message: string): void {
        if (this.isPro()) return;
        console.error(
            `%c${this.TAG}%c ${title}: %c${message}`,
            'background:#222;color:#fff;border-radius:3px 0 0 3px;padding:2px 6px;font-weight:bold;',
            'background:#ff4d4f;color:#fff;border-radius:0;padding:2px 6px;',
            'background:#fff3cd;color:#856404;border-radius:0 3px 3px 0;padding:2px 6px;'
        );
    }
}

export default LogUtils.getInstance();